import React, {useEffect, useState} from "react";
import _ from "lodash";
import XMarkIcon from "@heroicons/react/24/solid/XMarkIcon";
import {SEARCH_TARGETING_INPUT_FIELDS} from "../../constants/targeting.constant";
import RenderFields from "../../../common/ui/render-fields";
import ShowProgressSpinner from "../../../common/ui/show-progress-spinner";
import {handleFieldValueChanges, prepareInputFields} from "../../../common/utils/field-change-util";
import {addSingleTargeting, updateSingleTargeting} from "../../services/facebook-targeting-data.service";
import {searchTargeting} from "../../services/facebook-ads-service";
import {
    FACEBOOK_SEARCH_TARGETING_LOCATION_TYPES,
    FACEBOOK_SEARCH_TARGETING_TYPES
} from "../../constants/facebook-constant";
import SearchTargetingFilters from "./search-targeting-filters";
import ShowEmptyListMessage from "../../../design/components/common/show-empty-list-message";
import {TARGETING_INTEREST_FIELDS_LIST} from "../../constants/targeting-interest.constant";

const DEFAULT_TARGETING_SEARCH: any = {
    query: 'USA',
    type: FACEBOOK_SEARCH_TARGETING_TYPES.LOCATION,
    location_type: FACEBOOK_SEARCH_TARGETING_LOCATION_TYPES.COUNTRY,
}

const AddEditTargeting = ({
                              selectedTargeting = {},
                              refreshTargetingList,
                              isAddTargeting = false,
                              isEditTargeting = false
                          }) => {
    const [showModal, setShowModal] = useState(false);
    const [targeting, setTargeting] = useState(selectedTargeting);
    const [targetingSearch, setTargetingSearch] = useState(DEFAULT_TARGETING_SEARCH);
    const [saveInProgress, setSaveInProgress] = useState(false);
    const [targetingFieldInputs, setTargetingFieldInputs] = useState(SEARCH_TARGETING_INPUT_FIELDS);
    const [searchTargetingFilters, setSearchTargetingFilters] = useState(DEFAULT_TARGETING_SEARCH);
    const [targetingInterestsList, setTargetingInterestsList] = useState(null);
    const [dataFetchInProgress, setDataFetchInProgress] = useState(false);

    useEffect(() => {

        if (showModal) {
            if (isEditTargeting) {
                setTargeting(selectedTargeting);
            } else {
                setTargeting({});
            }
        }

    }, [showModal]);

    const handleConfirmAction = async () => {
        setSaveInProgress(true);

        const existingTargeting = {...targeting};

        if (isEditTargeting) {
            await updateSingleTargeting(existingTargeting);
        } else {
            await addSingleTargeting(existingTargeting);
        }

        setSaveInProgress(false);
        refreshTargetingList();
        setShowModal(false);
    }

    const handleTargetingChanges = (event) => {
        let existingTargeting = {...targeting};
        existingTargeting = handleFieldValueChanges(event, existingTargeting);
        setTargeting(existingTargeting);
    }

    /*const handleTargetingSearchChanges = (event) => {
        let existingTargetingSearch = {...targetingSearch};
        handleFieldValueChanges(event, existingTargetingSearch, setTargetingSearch);

        let existingTargetingSearch = {...targetingSearch};

        const {name} = event.target;
        if (name === 'campaignType') {
            const newFields = prepareInputFields(allFilterFields, event.target, existingFilterCriteria);
            setCampaignFilterFields(newFields);
        }

        handleFieldValueChanges(event, existingTargetingSearch, setTargetingSearch);
    }*/

    const handleCloseAction = () => {
        setShowModal(false);
    }

    const startTargetSearch = async () => {
        const existingTargetingSearch = {...searchTargetingFilters};
        console.log('existingTargetingSearch', existingTargetingSearch);

        const searchResults = await searchTargeting(existingTargetingSearch);
        setTargetingInterestsList(searchResults);
        console.log('searchResults', searchResults);
    }

    return (
        <>
            {isAddTargeting &&
                <button
                    className="button-green px-2 py-1"
                    onClick={() => setShowModal(true)}>
                    Add Targeting
                </button>
            }

            {isEditTargeting &&
                <button
                    className="button-green-outline px-3 py-1"
                    onClick={() => setShowModal(true)}>
                    Edit
                </button>
            }

            {showModal ? (
                <>
                    <div
                        className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-x-0 top-0 z-50 outline-none focus:outline-none">
                        <div className="relative w-1/2 my-6 mx-auto">
                            {/*content*/}
                            <div
                                className="border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-gray-100 outline-none focus:outline-none">
                                {/*header*/}
                                <div
                                    className="flex items-start justify-between p-5 border-b border-solid rounded-t">
                                    <h3 className="text-lg font-semibold">
                                        {isAddTargeting &&
                                            <>Add Targeting</>
                                        }

                                        {isEditTargeting &&
                                            <>Edit Targeting</>
                                        }
                                    </h3>

                                    <div className="">
                                        <button
                                            className="button-gray-outline px-1 py-1"
                                            onClick={handleCloseAction}>
                                            <div className="">
                                                <XMarkIcon className="h-6 w-6"/>
                                            </div>
                                        </button>
                                    </div>
                                </div>
                                {/*body*/}
                                <div className="relative p-5 flex-auto">
                                    <div className="leading-relaxed">
                                        <SearchTargetingFilters
                                            filterCriteria={searchTargetingFilters}
                                            setFilterCriteria={setSearchTargetingFilters}
                                            startTargetSearch={startTargetSearch}/>

                                        <div className="flex justify-start">

                                            <div
                                                className="w-full bg-white mt-4">

                                                <ShowEmptyListMessage
                                                    dataList={targetingInterestsList}
                                                    dataFetchInProgress={dataFetchInProgress}
                                                    label={'Targeting Interests'}/>

                                                {targetingInterestsList?.length > 0 &&
                                                    <table className="w-full">
                                                        <thead className="">
                                                        <tr>
                                                            <th className="p-2 border border-gray-400 bg-gray-400 text-white w-12">S.No</th>
                                                            {TARGETING_INTEREST_FIELDS_LIST?.map((targetingInterestField, rowIndex) => (
                                                                <th key={`th-${rowIndex}`}
                                                                    className={`p-2 border border-gray-400 bg-gray-400 text-white text-left pl-2 ${targetingInterestField?.cssClass}`}>{targetingInterestField?.label}</th>
                                                            ))}
                                                            {/*<th className="p-2 border border-gray-400 bg-gray-400 text-white">
                                    Actions
                                </th>*/}
                                                        </tr>
                                                        </thead>
                                                        <tbody className="">
                                                        {targetingInterestsList?.map((targetingInterest, rowIndex) => (
                                                            <tr key={`row-${rowIndex}`}
                                                                className="border border-gray-400">
                                                                <td className="p-2 border border-gray-400 m-auto">
                                                                    <div className="flex justify-center w-12">
                                                                        {rowIndex + 1}
                                                                    </div>
                                                                </td>

                                                                {TARGETING_INTEREST_FIELDS_LIST?.map((targetingInterestField, columnIndex) => (
                                                                    <React.Fragment
                                                                        key={`column-${rowIndex}-${columnIndex}`}>
                                                                        <td className={`p-2 border border-gray-400 m-auto ${targetingInterestField?.cssClass}`}>
                                                                            {targetingInterestField?.optionsMap &&
                                                                                <>{targetingInterestField?.optionsMap[targetingInterest[targetingInterestField?.attribute]]?.name}</>
                                                                            }

                                                                            {!targetingInterestField?.optionsMap &&
                                                                                <div
                                                                                    className={'flex justify-between items-center'}>
                                                                                    {!targetingInterestField?.isList &&
                                                                                        <> {targetingInterest[targetingInterestField?.attribute]}</>
                                                                                    }

                                                                                    {/*{targetingInterestField?.isAction &&
                                                                                        <div
                                                                                            className="flex justify-center ml-2">
                                                                                            <>
                                                                                                {relevantInterestsList?.indexOf(targetingInterest?.id) > -1 &&
                                                                                                    <button
                                                                                                        className="button-sky-outline px-1 py-0 w-28"
                                                                                                        onClick={() => removeRelevantInterest(targetingInterest)}>
                                                                                                        Relevant
                                                                                                    </button>
                                                                                                }

                                                                                                {relevantInterestsList?.indexOf(targetingInterest?.id) === -1 &&
                                                                                                    <button
                                                                                                        className="button-red-outline px-1 py-0 w-28"
                                                                                                        onClick={() => addRelevantInterest(targetingInterest)}>
                                                                                                        Not Relevant
                                                                                                    </button>
                                                                                                }
                                                                                            </>
                                                                                        </div>
                                                                                    }*/}

                                                                                    {targetingInterestField?.isList &&
                                                                                        <>
                                                                                            {_.join(targetingInterest[targetingInterestField?.attribute], ', ')}
                                                                                        </>
                                                                                    }

                                                                                    {targetingInterestField?.secondaryAttribute &&
                                                                                        <div
                                                                                            className={'text-gray-500 text-sm'}>
                                                                                            {targetingInterest[targetingInterestField?.secondaryAttribute]}
                                                                                        </div>
                                                                                    }
                                                                                </div>
                                                                            }
                                                                        </td>
                                                                    </React.Fragment>
                                                                ))}
                                                            </tr>
                                                        ))}
                                                        </tbody>
                                                    </table>
                                                }
                                            </div>

                                        </div>

                                    </div>
                                </div>
                                {/*footer*/}
                                <div
                                    className="flex items-center justify-end p-5 border-t border-solid border-blueGray-200 rounded-b">
                                    <div className="ml-4 -mt-1">
                                        <ShowProgressSpinner dataFetchInProgress={saveInProgress}/>
                                    </div>
                                    <button
                                        className="ml-2 text-gray-500 font-bold border border-gray-500 h-8 rounded px-4 outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
                                        type="button"
                                        onClick={() => setShowModal(false)}>
                                        Cancel
                                    </button>
                                    <button
                                        className="ml-2 bg-green-500 text-white active:bg-green-600 h-8 px-4 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
                                        type="button"
                                        onClick={handleConfirmAction}>
                                        Confirm Targeting
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
                </>
            ) : null}
        </>
    );
}

export default AddEditTargeting
